import { render, staticRenderFns } from "./VisitComments.vue?vue&type=template&id=2869e0e8&"
import script from "./VisitComments.vue?vue&type=script&lang=js&"
export * from "./VisitComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports